 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Policy
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.policyNo"
                            :label="filtersPolicyLabel.policyNo"
                            :error-messages="errors.collect('filterPolicy')"
                            data-vv-name="filterPolicy"
                            :data-vv-as="filtersPolicyLabel.policy"
                            v-validate="'entry|max:20|min_char:3'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="this.polHeader === 'polHeader1'">
        <v-data-table
          :headers="polHeaders"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="this.polHeader === 'polHeader2'">
        <v-data-table
          :headers="polHeaders2"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.endtCnt }}</td>
              <td>{{ row.item.insdName1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="this.polHeader === 'polHeader3'">
        <v-data-table
          :headers="polHeaders3"
          :items="polItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.polNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.polStat }}</td>
              <td>{{ formatDate(row.item.comDate) }}</td>
              <td>{{ formatDate(row.item.expDate) }}</td>
              <td>{{ row.item.insdName1 }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationPolicy: {
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.policyNo = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.policyNo = ''
      this.fetchPolicyData()
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          // this.paginationPolicy.page = 1
          this.fetchPolicyData()
        }
      })
    },
    assignPolicy(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-policy', data.polNo)
      this.$emit('assign-policy-info', data)
      this.$emit('close')
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearPolicyFilters()
      }
    },
    'paginationPolicy': function (value) {
      this.doClearPolicyFilters()
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin],
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    polHeader: {
      type: String,
      default: 'polHeader1'
    }
  }
}
</script>
